export type RealtyFilterVariant = 'desktop' | 'mobile';

export type RealtyFilterTemplateSetting = {
  enabled?: boolean;
  order?: number;
};

export type UnderConstructionSearchCapability = 'unavailable' | 'indexed';

export const KOSICEREAL_REALTY_FILTER_RECIPE = {
  offerTypeIds: [2, 1] as const,
  offerTypeTranslationKeys: {
    2: 'text1391',
    1: 'text1390',
  } as const,
  price: {
    min: 0,
    max: 120_000,
    step: 1_000,
  },
  area: {
    min: 0,
    max: 100,
    step: 1,
  },
  roomOptions: [
    { value: 0, translationKey: 'kosicereal_realty_filter_room_studio' },
    { value: 1, translationKey: 'kosicereal_realty_filter_room_1' },
    { value: 2, translationKey: 'kosicereal_realty_filter_room_2' },
    { value: 3, translationKey: 'kosicereal_realty_filter_room_3' },
    { value: 4, translationKey: 'kosicereal_realty_filter_room_4' },
    { value: 5, translationKey: 'kosicereal_realty_filter_room_5_plus' },
  ] as const,
  locationPlaceholderTranslationKey: 'kosicereal_realty_filter_location_placeholder',
} as const;

export const formatRealtyFilterNumber = (value: number) =>
  Math.round(value)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export const resolveRealtyFilterRangeBounds = (
  bounds: readonly [number, number],
  value: readonly [number | undefined, number | undefined],
  step: number,
): [number, number] => {
  const [minimum, maximum] = bounds;
  const highestExplicitValue = Math.max(
    ...value.filter((item): item is number => item !== undefined && Number.isFinite(item)),
    minimum,
  );

  if (highestExplicitValue < maximum) return [minimum, maximum];

  const span = maximum - minimum;
  if (span <= 0) return [minimum, maximum];

  const expandedMaximum =
    minimum + Math.ceil((highestExplicitValue - minimum + Math.max(step, 1)) / span) * span;

  return [minimum, expandedMaximum];
};
